export default __webpack_public_path__ + "static/media/addFileIcon.e7a016fb.svg";